export default __webpack_public_path__ + "static/VD_progress2-0714dd664b5cd4fe84900fda0c96971d.jpg";